module.exports = __webpack_public_path__ + "img/lc.c28d36aa.svg";